import Title from '../Title/Title';
import s from '../Experience/Experience.module.scss';
import { education } from '../Experience/consts';
import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import cn from 'classnames';
import { ExperienceItem } from '../Experience/Experience';


export default function Education() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section id="experience">
      <motion.div
        ref={ref}
        className={s.root_wrapper} style={{ minHeight: 'auto' }}
        initial={{ opacity: 0, y: 12 }}
        animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 12 }}
        transition={{ duration: 0.3, ease: 'easeOut' }}
      >
        <div className={s.root}>
          <Title
            text="Education"
            size="large"
            level={2}
            className={cn(s.header_title, s.education_title)}
          />
          <p className={cn(s.title_desc, s.education_desc)}>Academic education and achievements in the field of
                                                            information technology</p>

          <div className={s.experiences}>
            {education.map((experience, index) => (
              <ExperienceItem
                key={experience.title}
                experience={experience}
                index={index}
                isInView={isInView}
              />
            ))}
          </div>
        </div>
      </motion.div>
    </section>
  );
}
